import React from 'react';
import { Navigate } from "react-router-dom";
import CommonConfig from '../utils/constant';

const ProtectedRoute = (props) => {
    const loginData = CommonConfig.loginData('ERPLoginData');
    
    let meta = props.meta;

    React.useEffect(() => {
        document.title = meta.title;
    }, [meta])
    if (!loginData) {
        return <Navigate to="/" replace={true} />;
    }
    return props.children;
};

export default ProtectedRoute;